import React from 'react';
import { motion } from 'framer-motion';
import { images } from '../data/site';
const EASE = [0.23, 1, 0.32, 1] as const;
const stats = [{
  k: '100%',
  v: 'Halal bereid'
}, {
  k: 'Dagvers',
  v: 'In-house gebakken'
}, {
  k: '4.8',
  v: '102 Google reviews'
}];
export function Craft() {
  return <section id="ambacht" className="bg-paper px-6 py-20 lg:py-24" data-id="element-12" data-mp="3uxc1mo1a0l59">
      <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-2 lg:gap-16" data-id="element-13" data-mp="3uw0xgn3x5bdm">
        <div className="grid grid-cols-5 gap-4" data-id="element-14" data-mp="375wsocezv5l1">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-15%'
        }} transition={{
          duration: 0.28,
          ease: EASE
        }} className="col-span-3 aspect-[3/4] overflow-hidden rounded-3xl bg-sand" data-id="element-15" data-mp="32a7q007oh8ki">
            <img src={images.painAuChocolat} alt="Pain au chocolat met zichtbare laagjes" className="h-full w-full object-cover" data-id="element-16" data-mp="2og6xvpb8ejt4" />
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-15%'
        }} transition={{
          duration: 0.28,
          ease: EASE,
          delay: 0.08
        }} className="col-span-2 mt-10 aspect-[3/4] overflow-hidden rounded-3xl bg-sand" data-id="element-17" data-mp="16swulhm6b4tc">
            <img src={images.barista} alt="Barista schenkt melk in een kop koffie" className="h-full w-full object-cover" data-id="element-18" data-mp="nukk9sjizow6" />
          </motion.div>
        </div>

        <div data-id="element-19" data-mp="wuhee9oopfym">
          <p className="text-sm text-clay" data-id="element-20" data-mp="wtxvapnaslj0">Het ambacht</p>
          <h2 className="mt-4 text-[clamp(2rem,4vw,3.25rem)] font-semibold leading-[1.05] tracking-[-0.03em] text-ink" data-id="element-21" data-mp="11u2e4mbohsce">
            Handwerk, elke ochtend
          </h2>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-mist" data-id="element-22" data-mp="289wbrekt29u9">
            In onze patisserie in Amsterdam West vieren we het Franse ambacht. De beste smaak begint
            bij de beste ingrediënten — daarom wordt elk deeg met de hand gevouwen en dagvers
            gebakken.
          </p>
          <p className="mt-4 max-w-lg text-base leading-relaxed text-mist" data-id="element-23" data-mp="97h1d99g6r7w">
            Denk aan boterzachte croissants, pain au chocolat en brioches: een Weens ambacht dat in
            Frankrijk werd verfijnd, en bij ons dagelijks genot werd.
          </p>

          <dl className="mt-10 grid grid-cols-3 gap-6 border-t border-ink/10 pt-8" data-id="element-24" data-mp="3qmxm0hnw7mlp">
            {stats.map(stat => <div key={stat.k} data-id="element-25" data-mp="3lodzog5e08st">
                <dt className="text-xl font-semibold tracking-[-0.02em] text-ink lg:text-2xl" data-id="element-26" data-mp="46b737052vw9">
                  {stat.k}
                </dt>
                <dd className="mt-1.5 text-sm text-mist" data-id="element-27" data-mp="3vjxq4n16mfa6">{stat.v}</dd>
              </div>)}
          </dl>
        </div>
      </div>
    </section>;
}